import { useState } from "react";

import { inject, observer } from "mobx-react";

import { FileUpload } from "primereact/fileupload";

import "./style.scss";
import ButtonUI from "@UI/ButtonUI";

const UploadSortsFile = inject("mainStore")(
    observer(({ mainStore }) => {
        const [file, setFile] = useState(null);

        const handleUpload = async () => {
            console.log(file);
            const resp = await mainStore.uploadFile("/promo/offerbysitesortsupload", { file });
            if (resp.success) {
                mainStore.setMainStore("toast", { severity: "success", summary: `Загружена новая сортировка`, life: 6000 });
                mainStore.setMainStore("modal", false);
            }
        };

        const itemTemplate = (options) => {
            return (
                <div className="upload-sorts-file__file-item">
                    <div>
                        <span>{options?.name ?? "Нет имени"}</span>
                        <span>{options?.size ? `${(options.size / 1024).toFixed(2)} KB` : "0 KB"}</span>
                    </div>
                </div>
            );
        };

        const headerTemplate = (options) => {
            const { chooseButton, cancelButton, className } = options;

            return <div className={`${className} upload-sorts-file__header`}>{!file ? chooseButton : cancelButton}</div>;
        };
        return (
            <div className="upload-sorts-file">
                <label>Выберите файлы для загрузки</label>
                <FileUpload
                    name="upload-sorts-file"
                    accept=".csv"
                    maxFileSize={1000000}
                    emptyTemplate={<p className="m-0"></p>}
                    headerTemplate={headerTemplate}
                    chooseOptions={chooseOptions}
                    cancelOptions={cancelOptions}
                    onSelect={(e) => setFile(e?.files?.[0] ?? null)}
                    onClear={() => setFile(null)}
                    onRemove={() => setFile(null)}
                    itemTemplate={itemTemplate}
                    customUpload
                />

                <ButtonUI className="upload-sorts-file__upload-btn" label="Выполнить сортировку" severity="success" onClick={handleUpload} disabled={!file} />
            </div>
        );
    }),
);

const chooseOptions = { icon: "pi pi-fw pi-plus", className: "custom-choose-btn p-button-info", label: "Выбрать" };
const cancelOptions = { icon: "pi pi-fw pi-times", className: "custom-choose-btn p-button-danger", label: "Удалить файл" };

export default UploadSortsFile;
